import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import ShareIcon from "@mui/icons-material/Share";
import { RWebShare } from "react-web-share";
import Grid from "@mui/material/Grid";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import Achievements from "@mui/icons-material/EmojiEvents";
import Projects from "@mui/icons-material/DesktopWindows";
import GitHubIcon from "@mui/icons-material/GitHub";
import DescriptionIcon from "@mui/icons-material/Description";
import WalletIcon from "@mui/icons-material/AccountBalanceWallet";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  TextField,
  useMediaQuery,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Paper,
  Avatar,
  Chip,
  Stack,
  DialogActions,
  Tooltip,
  TablePagination,
  CircularProgress,
} from "@mui/material";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/splide/dist/css/splide.min.css"; // Splide core styles
import { useSelector, useDispatch } from "react-redux";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EmailIcon from "@mui/icons-material/Email";
import SchoolIcon from "@mui/icons-material/School";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";
import WorkIcon from "@mui/icons-material/Work";
import LanguageIcon from "@mui/icons-material/Language";
import ToolsComponent from "../components/resultpagecarousel/ToolsComponent";
import { styled } from "@mui/material/styles";
import {
  setResultPageCarousel,
  setUserPublicResult,
} from "../redux/action/result";
import { getPublicResult } from "../components/stepper_form/stepper.helper";
import { useFeatureFlag } from "@harnessio/ff-react-client-sdk";
import { useNavigate } from "react-router-dom";
import { BorderColor } from "@mui/icons-material";
import { getIconBySkillPathName } from "../components/common/GlobalFunction";

const ResultCarousel = ({
  uuid,
  convertedMarketSalary,
  convertedTechValue,
  resultTime,
}) => {
  const getIconByToolName = async (skillName) => {
    const svgIconPath = `${process.env.PUBLIC_URL}/assets/images/icons/${skillName}.svg`;
    const pngIconPath = `${process.env.PUBLIC_URL}/assets/images/icons/${skillName}.png`;
    const darkIconPath = `${process.env.PUBLIC_URL}/assets/images/dark-icons/${skillName}.svg`;

    if (await imageExists(svgIconPath)) {
      return svgIconPath;
    } else if (await imageExists(pngIconPath)) {
      return pngIconPath;
    } else if (await imageExists(darkIconPath)) {
      return darkIconPath;
    }
    return null;
  };
  const isMobile = useMediaQuery("(max-width:600px)");
  const isTablet = useMediaQuery("(min-width:601px) and (max-width:1024px)");

  const professionalBackgroundData = [
    {
      name: "Role",
      icon: "/assets/images/professional-background/default/role.gif",
      key: "role",
    },
    {
      name: "Team Functioning",
      icon: "/assets/images/professional-background/default/teamFunctioning.gif",
      key: "teamFunctioning",
    },
    {
      name: "Company",
      icon: "/assets/images/professional-background/default/typeOfCompany.gif",
      key: "typeOfCompany",
    },
    {
      name: "Current Company",
      icon: "/assets/images/professional-background/default/currentCompany.gif",
      key: "currentCompany",
    },
    {
      name: "Oral Communication",
      icon: "/assets/images/professional-background/default/oralCommunicationSkill.gif",
      key: "oralCommunicationSkill",
    },
    {
      name: "Written Communication",
      icon: "/assets/images/professional-background/default/writtenCommunicationSkill.gif",
      key: "writtenCommunicationSkill",
    },
    {
      name: "Hands-on Experience",
      icon: "/assets/images/professional-background/default/handsOn.gif",
      key: "handsOn",
    },
    {
      name: "Global Exposure",
      icon: "/assets/images/professional-background/default/internationalExposure.gif",
      key: "internationalExposure",
    },
    {
      name: "Certificate",
      icon: "/assets/images/professional-background/default/certificationList.gif",
      key: "certificationList",
    },
    {
      name: "Domain",
      icon: "/assets/images/professional-background/default/domainArea.gif",
      key: "domainArea",
    },
  ];

  const imageExists = (url) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);
      img.src = url;
    });
  };

  const dispatch = useDispatch();
  const path = window.location.pathname;
  const pathParts = path.split("/");
  // const uuid = pathParts[pathParts.length - 1];
  const [pageLoading, setPageLoading] = useState(true);
  const [errorPublicPage, setErrorPublicPage] = useState({
    error: false,
    message: "",
    status: 400,
  });
  const MaintenanceMessage = useFeatureFlag("Maintenance_Break");
  const CalculateButtonValue = useFeatureFlag("Calculate_Button_text");
  const navigate = useNavigate();

  useEffect(() => {
    getPublicResult(
      dispatch,
      setUserPublicResult,
      uuid,
      setPageLoading,
      setErrorPublicPage
    );
  }, []);

  const [shareLink, setShareLink] = useState(
    `${process.env.REACT_APP_BASE_URL}/public-profile/${uuid}`
  );

  const resultData = useSelector(
    (state) => state?.ResultReducer?.resumeCarousel || []
  );

  const publicResult = useSelector(
    (state) => state?.ResultReducer?.publicResult || []
  );

  const Img = styled("img")({
    maxWidth: { xs: "35px !important", md: "56px" },
    maxHeight: "100%",
    width: "100%",
  });
  const [skillsData, setSkillsData] = useState({
    primarySkill: [],
    secondarySkill: [],
    AllTools: [],
    AIToolsList: [],
    softwareToolsList: [],
  });
  const [loading, setLoading] = React.useState(false);
  useEffect(() => {
    const fetchSkillsWithIcons = async () => {
      setLoading(true);
      // Fetch primary skills with icons
      const primarySkills = await Promise.all(
        resultData?.primarySkill?.map(async (skill) => {
          const optionsWithColor = checkYearWithGpt(skill);
          const skillBackgroundColor = optionsWithColor.barSecondaryColor;
          const skillTextColor = optionsWithColor.color;
          const iconUrl = await getIconBySkillPathName(
            skill.imgPath,
            skill.name
          ); // Await if async
          return { ...skill, iconUrl, skillBackgroundColor, skillTextColor };
        }) || []
      );

      // Fetch secondary skills with icons
      const secondarySkills = await Promise.all(
        resultData?.secondarySkill?.map(async (skill) => {
          const optionsWithColor = checkYearWithGpt(skill);
          const skillBackgroundColor = optionsWithColor.barSecondaryColor;
          const skillTextColor = optionsWithColor.color;
          const iconUrl = await getIconBySkillPathName(
            skill.imgPath,
            skill.name
          ); // Await if async
          return { ...skill, iconUrl, skillBackgroundColor, skillTextColor };
        }) || []
      );

      // Fetch all tools with icons
      // const toolsWithIcons = await Promise.all(
      //   resultData?.AllTools?.map(async (tool) => {
      //     const iconUrl = await getIconBySkillName(tool.name); // Fetch icon for each tool
      //     return { ...tool, iconUrl }; // Append iconUrl to each tool object
      //   }) || []
      // );

      // Fetch Ai tools with icons
      const aitoolsIcons = await Promise.all(
        resultData?.AIToolsList?.map(async (tool) => {
          const iconUrl = await getIconByToolName(tool.name); // Fetch icon for each tool
          return { ...tool, iconUrl }; // Append iconUrl to each tool object
        }) || []
      );

      // Fetch Software tools with icons
      const softwaretoolsIcons = await Promise.all(
        resultData?.softwareToolsList?.map(async (tool) => {
          const iconUrl = await getIconByToolName(tool.name); // Fetch icon for each tool
          return { ...tool, iconUrl }; // Append iconUrl to each tool object
        }) || []
      );

      // const colors = checkYearWithGpt(relevanceResultData[0]);
      // const newSkills = primarySkills?.map((item) => {
      //   if (item?.name === relevanceResultData[0]["name"]) {
      //     return (item = { ...item });
      //   } else {
      //     return item;
      //   }
      // });

      // Update state with both primary and secondary skills
      setSkillsData({
        primarySkill: primarySkills,
        secondarySkill: secondarySkills,
        // AllTools: toolsWithIcons,
        AIToolsList: aitoolsIcons,
        softwareToolsList: softwaretoolsIcons,
      });

      setLoading(false);
    };

    if (resultData) {
      fetchSkillsWithIcons(); // Call the async function
    } else {
      setLoading(false); // If no resultData, set loading to false
    }
  }, [resultData]); // Dependency on resultData
  const userForm = useSelector((state) => state?.ResultReducer?.resumeCarousel);

  function extractCityState() {
    let locationString = userForm?.location;
    // Find the index of the last comma
    let lastIndex = locationString.lastIndexOf(",");
    // Extract the substring up to the last comma
    let result = locationString.substring(0, lastIndex);
    // setJobLocation(result);
  }

  // useEffect(() => {
  //   // extractCityState();
  //   // convertCurrency();
  //   getResultPageCarousel(dispatch, setResultPageCarousel);
  // }, []);
  function GetBackGroundColor(skillDemand, type) {
    if (skillDemand === "Trending") {
      switch (type) {
        case "y":
          return "#278C37";
        case "tech":
          return "#278C37";
        case "mgmt":
          return "#30B044";
        case "management":
          return "#30B044";
        case "generic":
          return "#38C94E";
        default:
          return "#278C37";
      }
    }
    if (skillDemand === "Obsolete") {
      switch (type) {
        case "y":
          return "#028EDF";
        case "tech":
          return "#028EDF";
        case "mgmt":
          return "#09A2FA";
        case "management":
          return "#09A2FA";
        case "generic":
          return "#79CDFD";
        default:
          return "#028EDF";
      }
    }
    if (skillDemand === "In demand") {
      switch (type) {
        case "y":
          return "#E9B112";
        case "tech":
          return "#E9B112";
        case "mgmt":
          return "#FEC113";
        case "management":
          return "#FEC113";
        case "generic":
          return "#FAD15D";
        default:
          return "#E9B112";
      }
    }
    if (skillDemand === "Getting outdated fast") {
      switch (type) {
        case "y":
          return "#C60015";
        case "tech":
          return "#C60015";
        case "mgmt":
          return "#E2031B";
        case "management":
          return "#E2031B";
        case "generic":
          return "#FF465A";
        default:
          return "#C60015";
      }
    }
  }
  function checkYearWithGpt(option) {
    const year = option?.expiryYear;
    const currentYear = new Date().getFullYear();
    const minYearDiff = 5;
    const minYearForOutdatedSkill = 4;
    const minYearForCurrentSkill = 1;

    if (!year) {
      return {
        label: "Default",
        barPrimaryColor: "#e0e0e0",
        barSecondaryColor: "#e0e0e0",
      };
    }

    if (year > currentYear) {
      if (option?.chat_gpt === false && option?.estYear === 2010) {
        return {
          label: `Obsolete`,
          barPrimaryColor: "#028EDF",
          // barSecondaryColor: "#FFCDD2",
          barSecondaryColor: GetBackGroundColor("Obsolete", option?.type),
          // color: "red",
          BorderColor: "#fff",
          color: "#0F0D0E",
        };
      } else {
        return {
          label: `Trending`,
          barPrimaryColor: "#278C37",
          // barSecondaryColor: "#A5D6A7",
          barSecondaryColor: GetBackGroundColor("Trending", option?.type),
          // color: "#26801E",
          BorderColor: "#fff",
          color: "#0F0D0E",
        };
      }
    } else if (year >= currentYear - minYearForCurrentSkill) {
      return {
        label: `In demand`,
        barPrimaryColor: "#E9B112",
        // barSecondaryColor: "#ffcc80",
        barSecondaryColor: GetBackGroundColor("In demand", option?.type),
        // color: "darkorange",
        BorderColor: "#fff",
        color: "#0F0D0E",
      };
    } else if (year >= currentYear - minYearForOutdatedSkill) {
      return {
        label: `Getting outdated fast`,
        barPrimaryColor: "#C60015",
        // barSecondaryColor: "#fff59d",
        barSecondaryColor: GetBackGroundColor(
          `Getting outdated fast`,
          option?.type
        ),
        // color: "#FF9D09",
        BorderColor: "#fff",
        color: "#0F0D0E",
      };
    } else if (year <= currentYear - minYearDiff) {
      return {
        label: `Obsolete `,
        barPrimaryColor: "#028EDF",
        // barSecondaryColor: "#FFCDD2",
        barSecondaryColor: GetBackGroundColor(`Obsolete`, option?.type),
        // color: "red",
        BorderColor: "#fff",
        color: "#0F0D0E",
      };
    }
  }
  const Legend = () => {
    const currentYear = new Date().getFullYear();
    const years = [
      currentYear + 1,
      currentYear,
      currentYear - 2,
      currentYear - 6,
    ];

    return (
      <Grid
        container
        spacing={1}
        sx={{ mb: 2, display: "flex", justifyContent: "center" }}
      >
        {years.map((year, index) => {
          const option = { expiryYear: year };
          const yearInfo = checkYearWithGpt(option);
          return (
            <Grid item key={index}>
              <Chip
                label={yearInfo.label}
                // className={year > currentYear ? "shine-effect" : ""}
                sx={{
                  backgroundColor: yearInfo?.barSecondaryColor,
                  color: "#fff" || "rgba(0, 0, 0, 0.87)",
                  border: `1px solid ${yearInfo.BorderColor}`,
                }}
              />
            </Grid>
          );
        })}
      </Grid>
    );
  };
  const DynamicIcon = ({ defaultIcon }) => {
    return (
      <Box
        component="img"
        src={defaultIcon} // Always use the default icon
        alt="Default Icon"
        sx={{
          width: "70px",
          height: "70px",
        }}
      />
    );
  };

  const isValidValue = (value) => {
    return (
      value !== undefined &&
      value !== null &&
      value !== "" &&
      value !== "No" &&
      value !== "Certification Name" &&
      !(Array.isArray(value) && value.length === 0) &&
      !(typeof value === "object" && Object.keys(value).length === 0) // Exclude empty objects
    );
  };

  const fieldNameMappings = {
    AIToolsList: "AI Tools",
    AItoolsUsing: "Using AI Tools",
    WhichEnvironments: "Environments",
    abilityDesign: "Ability to Design",
    achievements: "Achievements",
    applicationSupport: "Application Support",
    businessAcumen: "Business Acumen",
    certificationList: "Certification",
    certifications: "Certifications",
    currentCompany: "Current Company",
    dataProjectList: "Data Projects",
    dataRelatedProject: "Data Related Projects",
    dataStreamingHandled: "Data Streaming",
    debugAbility: "Debugging Ability",
    domain: "Domain",
    domainArea: "Domain Area",
    domainExpertise: "Domain Expertise",
    education: "Education",
    educationalQualification: "Educational Qualification",
    email: "Email",
    experience: "Total Experience (Months)",
    githubUrl: "GitHub Profile",
    handsOn: "Hands-on Experience",
    hobbies_interests: "Hobbies & Interests",
    innovationCreativity: "Innovation & Creativity",
    internationalExposure: "International Exposure",
    languages: "Spoken Languages",
    linkedInUrl: "LinkedIn Profile",
    location: "Location",
    multiCulturalTeam: "Worked in Multi-Cultural Team",
    multiLanguage: "Multi-Language Proficiency",
    name: "Full Name",
    nonFunctionalExposure: "Non-Functional Exposure",
    oralCommunicationSkill: "Oral Communication",
    performanceTuning: "Performance Tuning",
    primarySkill: "Primary Skills",
    projects: "Projects",
    prowess: "Prowess",
    prowessReferencesValue: "Prowess References",
    references: "References",
    remoteWorking: "Remote Working",
    role: "Role",
    roleSeniority: "Seniority",
    secondarySkill: "Secondary Skills",
    softwareToolsList: "Software Tools",
    softwareToolsUsing: "Software Tools Using",
    teamFunctioning: "Team Functioning",
    teamHandling: "Team Size",
    teamHandlingCapacity: "Team Handling Capacity",
    typeOfCompany: "Type of Company",
    typeOfScale: "Type of Scale",
    whichApplicationsProducts: "Applications",
    whichPerformanceTuning: "Performance Tuning",
    whichProducts: "Products",
    whichTeams: "Multicultural Exposure",
    whichTiers: "N-tiers",
    workActivities: "Work Activities",
    workExperience: "Work Experience",
    writtenCommunicationSkill: "Written Communication",
  };

  // Ensure userForm is an object
  const userFormData = userForm || {};

  // Step 1: Get all field names dynamically
  const allFields = Object.keys(userFormData);

  // Step 2: Find missing fields dynamically
  const missingFields = allFields.filter(
    (field) =>
      !userFormData[field] || // If the field is empty, null, or undefined
      (Array.isArray(userFormData[field]) && userFormData[field].length === 0) // If it's an empty array
  );

  const hasMissingFields = missingFields.length > 0;

  const hasFilledFields = [
    // { name: "AI Tools List", key: "AIToolsList" },
    // { name: "Using AI Tools", key: "AItoolsUsing" },
    { name: "Environments", key: "WhichEnvironments" },
    { name: "Ability to Design", key: "abilityDesign" },
    // { name: "Achievements", key: "achievements" },
    { name: "Application Support", key: "applicationSupport" },
    { name: "Business Acumen", key: "businessAcumen" },
    // { name: "Certification List", key: "certificationList" },
    // { name: "Certifications", key: "certifications" },
    // { name: "Current Company", key: "currentCompany" },
    { name: "Data Projects", key: "dataProjectList" },
    { name: "Data Related Projects", key: "dataRelatedProject" },
    { name: "Data Streaming Handled", key: "dataStreamingHandled" },
    { name: "Debugging Ability", key: "debugAbility" },
    // { name: "Domain", key: "domain" },
    { name: "Domain Area", key: "domainArea" },
    { name: "Domain Expertise", key: "domainExpertise" },
    // { name: "Education", key: "education" },
    // { name: "Educational Qualification", key: "educationalQualification" },
    // { name: "Email", key: "email" },
    // { name: "Total Experience (Months)", key: "experience" },
    // { name: "GitHub Profile", key: "githubUrl" },
    // { name: "Hands-on Experience", key: "handsOn" },
    // { name: "Hobbies & Interests", key: "hobbies_interests" },
    { name: "Innovation & Creativity", key: "innovationCreativity" },
    // { name: "International Exposure", key: "internationalExposure" },
    // { name: "Languages Spoken", key: "languages" },
    // { name: "LinkedIn Profile", key: "linkedInUrl" },
    // { name: "Location", key: "location" },
    { name: "Worked in Multi-Cultural Team", key: "multiCulturalTeam" },
    { name: "Multi-Language Proficiency", key: "multiLanguage" },
    // { name: "Full Name", key: "name" },
    { name: "Non-Functional Exposure", key: "nonFunctionalExposure" },
    // { name: "Oral Communication", key: "oralCommunicationSkill" },
    // { name: "Payload Type", key: "payloadType" },
    { name: "Performance Tuning", key: "performanceTuning" },
    // { name: "Primary Skills", key: "primarySkill" },
    // { name: "Projects", key: "projects" },
    { name: "Prowess", key: "prowess" },
    // { name: "Prowess References", key: "prowessReferencesValue" },
    // { name: "References", key: "references" },
    { name: "Mode of Working", key: "remoteWorking" },
    // { name: "Role", key: "role" },
    { name: "Seniority", key: "roleSeniority" },
    // { name: "Secondary Skills", key: "secondarySkill" },
    // { name: "Software Tools List", key: "softwareToolsList" },
    // { name: "Software Tools Using", key: "softwareToolsUsing" },
    // { name: "Team Functioning", key: "teamFunctioning" },
    { name: "Team Size", key: "teamHandling" },
    { name: "Team Handling Capacity", key: "teamHandlingCapacity" },
    // { name: "Type of Company", key: "typeOfCompany" },
    { name: "Type of Scale", key: "typeOfScale" },
    { name: "Which Applications/Products", key: "whichApplicationsProducts" },
    { name: "Which Performance Tuning", key: "whichPerformanceTuning" },
    { name: "Which Products", key: "whichProducts" },
    { name: "Which Teams", key: "whichTeams" },
    { name: "Which Tiers", key: "whichTiers" },
    // { name: "Work Activities", key: "workActivities" },
    // { name: "Work Experience", key: "workExperience" },
    // { name: "Written Communication", key: "writtenCommunicationSkill" },
  ];

  // Step 2: Filter only fields that have values
  const filledFields = hasFilledFields.filter(
    ({ key }) =>
      userFormData[key] && // Field exists
      (!Array.isArray(userFormData[key]) || userFormData[key].length > 0) // Not an empty array
  );

  const hasFilledValues = filledFields.length > 0;

  const isValidName = (name) => {
    if (!name || typeof name !== "string") return false;

    const trimmedName = name.trim().toLowerCase();
    const invalidNames = ["", "unknown", "your name", "Your Name", "YOUR NAME"];

    return !invalidNames.includes(trimmedName);
  };

  const isValidLocation = (location) => {
    if (!location || typeof location !== "string") return false;

    const trimmedLocation = location.trim().toLowerCase();
    const invalidLocations = ["", "unknown", "city, country", "city,country"];

    return !invalidLocations.includes(trimmedLocation);
  };
  const IncognitoModeStatus = useSelector(
    (state) => state.IncognitoMode?.IncognitoUser || false
  );
  const New_Theme = useFeatureFlag("New_Theme");

  // Get the current theme's text color and typography
  const currentThemeKey =
    useSelector((state) => state.themeReducer?.currentTheme) || 0;
  const themes = useSelector((state) => state.themeReducer?.themes);
  const currentTheme = themes[currentThemeKey];

  const currentFontKey =
    useSelector((state) => state.themeReducer?.currentFont) || "default";
  const fonts = useSelector((state) => state.themeReducer?.fonts);
  const currentFont = fonts[currentFontKey];

  const muiTheme = createTheme({
    // typography: {
    //   fontFamily: ,
    // },
    palette: {
      // border: { main: currentTheme.border }, // Use the border color for primary
      // icon: { main: currentTheme.icon }, // Use the icon color for secondary
      // text: { primary: currentTheme.text }, // Use the text color
      primary: { main: currentTheme.primary }, // Use the primary color
      secondary: { main: currentTheme.secondary }, // Use the secondary color
    },
    palette: {
      primary: {
        // light: will be calculated from palette.primary.main,
        main: "#26801E",
        border: New_Theme
          ? IncognitoModeStatus
            ? "#fff"
            : "#21175E"
          : "#26801E",
        evalute: "#2BB344",
        evalutebackground: "#EEFFF1",
        incognitoBackground: "#999999",
        incognitoText: "#fff",
        nestedQuestionBackground: New_Theme
          ? IncognitoModeStatus
            ? "#ebebeb"
            : "#edfff1"
          : "#edfff1",
        nestedQuestionBorder: "1px solid #fff",

        // dark: will be calculated from palette.primary.main,
        // contrastText: will be calculated to contrast with palette.primary.main
      },
      secondary: {
        light: "#0066ff",
        main: "#0044ff",
        // dark: will be calculated from palette.secondary.main,
        contrastText: "#ffcc00",
      },
      error: {
        // light: "#0066ff",
        main: "#EF4F38",
        // dark: will be calculated from palette.secondary.main,
        // contrastText: "#ffcc00",
      },
      text: {
        primary: "#000",
        pricing: "#000",
      },
      // Provide every color token (light, main, dark, and contrastText) when using
      // custom colors for props in Material UI's components.
      // Then you will be able to use it like this: `<Button color="custom">`
      // (For TypeScript, you need to add module augmentation for the `custom` value)
      custom: {
        light: "#ffa726",
        main: "#f57c00",
        dark: "#ef6c00",
        contrastText: "rgba(0, 0, 0, 0.87)",
      },

      // Used by `getContrastText()` to maximize the contrast between
      // the background and the text.
      contrastThreshold: 3,
      // Used by the functions below to shift a color's luminance by approximately
      // two indexes within its tonal palette.
      // E.g., shift from Red 500 to Red 300 or Red 700.
      tonalOffset: 0.2,
    },
    typography: {
      fontFamily: currentFont,
      fontSize: 14,
      fontWeightLight: 300,
      fontWeightRegular: 400,
      fontWeightMedium: 500,
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            fontSize: "18px",
            // color: "#727272",
            color: "#232323",
            // "& h1,h2": {
            //   color: "black",
            // },
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            fontSize: "16px",
            textTransform: "none",
            borderRadius: 28,
            padding: "8px 30px",
            minWidth: "unset",
          },
          contained: {
            // Targeting contained variant
            root: {
              fontSize: "16px",
              textTransform: "none",
              borderRadius: 28,
              padding: "8px 30px",
              minWidth: "unset",
              backgroundColor: New_Theme ? "#0D9B21" : "#26801E",
              color: "#fff",
              "&:hover": {
                backgroundColor: New_Theme ? "#35b848 !important" : "#fff",
              },
            },
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          input: {
            borderColor: New_Theme ? "#21175E" : "#26801E",
            "&:focus": {
              borderColor: New_Theme ? "#21175E" : "#26801E",
            },
            "&:active": {
              borderColor: New_Theme ? "#21175E" : "#26801E",
            },
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: New_Theme ? "#21175E" : "#26801E",
              borderWidth: "2px",
              color: "#000",
            },
            backgroundColor: "#fff", // Background color of the Select component
          },
        },
      },
      MuiSelect: {
        styleOverrides: {
          select: {
            "&:focus": {
              borderColor: New_Theme ? "#21175E" : "#26801E", // Change this to your desired focus border color
            },
            "&:active": {
              borderColor: New_Theme ? "#21175E" : "#26801E", // Change this to your desired active border color
            },
            "&.MuiAutocomplete-option": {
              backgroundColor: "#fff", // Background color of the Select component
            },
          },
        },
      },
      MuiAutocomplete: {
        styleOverrides: {
          inputRoot: {
            borderColor: New_Theme ? "#21175E" : "#26801E", // Change this to your desired border color
            "&:focus": {
              borderColor: New_Theme ? "#21175E" : "#26801E", // Change this to your desired focus border color
            },
            "&:active": {
              borderColor: New_Theme ? "#21175E" : "#26801E", // Change this to your desired active border color
            },
          },
          popper: {
            "& .MuiPaper-root": {
              backgroundColor: "#fff", // Background color of the dropdown
            },
          },
        },
      },
      MuiFormControl: {
        styleOverrides: {
          root: {
            borderColor: New_Theme ? "#21175E" : "#26801E", // Change this to your desired border color
            "&:focus": {
              borderColor: New_Theme ? "#21175E" : "#26801E", // Change this to your desired focus border color
            },
            "&:active": {
              borderColor: New_Theme ? "#21175E" : "#26801E", // Change this to your desired active border color
            },
          },
        },
      },
      MuiFormLabel: {
        styleOverrides: {
          root: {
            "&.Mui-focused": {
              color: New_Theme ? "#21175E" : "#26801E", // Change this to your desired color for focused label
            },
            color: "#000",
          },
        },
      },
      MuiRadio: {
        styleOverrides: {
          root: {
            color: New_Theme ? "#21175E" : "#26801E", // Change this to your desired color for radio buttons
          },
        },
      },
    },
    // breakpoints: {
    //   ...customBreakpoints,
    // },
  });
  muiTheme.typography.h1 = {
    fontSize: "3rem",
    lineHeight: "3rem",
    fontFamily: currentFont,

    "@media (max-width:600px)": {
      fontSize: "2.2rem",
    },
    [muiTheme.breakpoints.up("md")]: {
      fontSize: "3rem",
    },
  };
  muiTheme.typography.h2 = {
    fontSize: "2.125rem",
    lineHeight: "2.125rem",
    fontFamily: currentFont,

    "@media (max-width:600px)": {
      fontSize: "1.625rem",
    },
    [muiTheme.breakpoints.up("md")]: {
      fontSize: "2rem",
    },
  };
  muiTheme.typography.h3 = {
    fontSize: "1.75rem",
    lineHeight: "1.75rem",
    fontFamily: currentFont,

    "@media (max-width:600px)": {
      fontSize: "1.375rem",
    },
    [muiTheme.breakpoints.up("md")]: {
      fontSize: "1.6rem",
    },
  };
  muiTheme.typography.h4 = {
    fontSize: "1.5rem",
    lineHeight: "2rem",
    fontFamily: currentFont,

    "@media (max-width:600px)": {
      fontSize: "1.25rem",
    },
    [muiTheme.breakpoints.up("md")]: {
      fontSize: "1.4rem",
    },
  };
  muiTheme.typography.h5 = {
    fontSize: "1.2rem",
    lineHeight: "1.5rem",
    fontFamily: currentFont,

    "@media (max-width:600px)": {
      fontSize: "1rem",
    },
    [muiTheme.breakpoints.up("md")]: {
      fontSize: "1.4rem",
    },
  };
  muiTheme.typography.h6 = {
    fontSize: "1.2rem",
    lineHeight: "1.5rem",
    fontFamily: currentFont,

    "@media (max-width:600px)": {
      fontSize: "1rem",
    },
    [muiTheme.breakpoints.up("md")]: {
      fontSize: "1.4rem",
    },
  };

  const istTimeString = new Date(resultTime).toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "long", // 👈 This gives you "April", "March", etc.
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });

  return (
    <ThemeProvider theme={muiTheme}>
      <>
        <Box
          sx={{
            // maxWidth: "1200px",
            // margin: "auto",
            // px: { xs: 2, sm: 3, md: 5 },
            py: 3,
            // mt: { xs: "40px", lg: "50px" },
            // py: { xs: 3, sm: 3, md: 3, lg: 3, xl: 0 },
            // bgcolor: "#f9f9f9",
            // borderRadius: "12px",
            // boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          }}
        >
          <Grid item xs={12}>
            <Box
              sx={{
                mt: { xs: "45px", md: "20px" },
                px: { xs: 2, sm: 3, md: 10 },
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  minWidth: {
                    xs: "100%",
                    md: "100%",
                    lg: "90%",
                  },
                  maxWidth: {
                    xs: "100%",
                    md: "100%",
                    lg: "90%",
                  },
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    alignItems: "center",
                    justifyContent: "space-between",
                    backgroundColor: "#191715",
                    color: "#FFF",
                    borderRadius: "12px",
                    padding: {
                      xs: "10px 10px",
                      lg: "20px 20px",
                    },
                    width: "100%",
                    mb: {
                      xs: "15px",
                      md: "20px",
                      lg: "25px",
                    },
                  }}
                >
                  {/* Left Section: User Info */}
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      {isValidName(userForm?.name) && (
                        <Typography
                          sx={{
                            fontSize: {
                              xs: "16px",
                              lg: "28px",
                            },
                            fontWeight: 700,
                            textAlign: { xs: "left", lg: "left" },
                            lineHeight: {
                              xs: "18px",
                              lg: "34px",
                            },
                            color: "#FDF9E0",
                            WebkitBackgroundClip: "text",
                            backgroundClip: "text",
                            flexGrow: 1,
                            wordWrap: "break-word",
                          }}
                        >
                          {/* {`${userForm?.name?.trim()}'s`} */}
                          {`${userForm?.name?.trim()}`}
                        </Typography>
                      )}
                    </Box>

                    {userForm?.fileUrl && (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "flex-start",
                          justifyContent: "flex-start",
                        }}
                      >
                        <Box
                          component="div"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            mt: "4px",
                          }}
                        >
                          <Link
                            sx={{
                              color: currentTheme.primary,
                              fontSize: {
                                xs: "12px",
                                lg: "16px",
                              },
                              fontWeight: 500,
                              lineHeight: {
                                xs: "12px",
                                lg: "26px",
                              },
                              display: "flex",
                              alignItems: "center",
                              textDecorationColor: currentTheme.primary,
                            }}
                            href={userForm?.fileUrl} // ✅ Use dynamic resume file URL
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View Resume
                            <OpenInNewIcon
                              sx={{
                                fontSize: "large",
                                width: {
                                  xs: "12px",
                                  lg: "20px",
                                },
                                height: {
                                  xs: "12px",
                                  lg: "20px",
                                },
                                color: currentTheme.primary,
                                ml: "5px",
                              }}
                            />
                          </Link>
                        </Box>
                      </Box>
                    )}
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      mt: {
                        xs: "5px",
                        md: "0px",
                      },
                    }}
                  >
                    {userForm?.experience && (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: {
                            xs: "flex-start",
                            sm: "flex-start",
                            md: "flex-start",
                            lg: "center",
                          },
                        }}
                      >
                        <Card
                          sx={{
                            border: `1px  dashed ${currentTheme.primary}`,
                            borderRadius: {
                              xs: "6px",
                              lg: "10px",
                            },
                            boxShadow: "none",
                            padding: {
                              xs: "6px",
                              lg: "15px",
                            },
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: currentTheme.secondary,
                          }}
                        >
                          <CardContent sx={{ p: "0 !important", flexGrow: 1 }}>
                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: 1,
                              }}
                            >
                              <Typography
                                variant="h4"
                                sx={{
                                  fontWeight: "700",
                                  display: "flex",
                                  alignItems: "center",
                                  textAlign: "center",
                                  lineHeight: {
                                    xs: "16px",
                                    lg: "32px",
                                  },
                                  fontWeight: {
                                    xs: 400,
                                    lg: 500,
                                  },
                                  color: "#FDF9E0",
                                  fontSize: {
                                    xs: "12px",
                                    lg: "22px",
                                  },
                                }}
                              >
                                {isNaN(userForm?.experience)
                                  ? `Total experience of ${userForm?.experience}`
                                  : (() => {
                                      const totalMonths = parseInt(
                                        userForm?.experience,
                                        10
                                      );

                                      // Convert months to years and months
                                      const years = Math.floor(
                                        totalMonths / 12
                                      );
                                      const months = totalMonths % 12;

                                      // Build the experience string
                                      let experienceText = "";
                                      if (years > 0) {
                                        experienceText += `${years} ${
                                          years > 1 ? "Years" : "Year"
                                        }`;
                                      }
                                      if (months > 0) {
                                        experienceText += ` ${months} ${
                                          months > 1 ? "Months" : "Month"
                                        }`;
                                      } else if (totalMonths === 0) {
                                        return `Fresher/Intern/Trainee`;
                                      }
                                      // if(months)

                                      return `Total experience of ${experienceText}`;
                                    })()}
                              </Typography>
                            </Box>
                          </CardContent>
                        </Card>
                      </Box>
                    )}
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      gap: 1,
                      mt: {
                        xs: "5px",
                        md: "0px",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: {
                          xs: "flex-start",
                          sm: "flex-start",
                          md: "flex-start",
                          lg: "center",
                        },
                      }}
                    >
                      {(userForm?.githubUrl || userForm?.linkedInUrl) && (
                        <Box
                          sx={{
                            display: { xs: "flex", sm: "flex" },
                            flexWrap: "wrap",
                            alignItems: "center",
                            gap: 1,
                          }}
                        >
                          {userForm?.linkedInUrl && (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "flex-start",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Box
                                component="a"
                                href={`https://${userForm.linkedInUrl.replace(
                                  /^https?:\/\//,
                                  ""
                                )}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: {
                                    xs: "30px",
                                    lg: "40px",
                                  }, // Adjust as needed
                                  height: {
                                    xs: "30px",
                                    lg: "40px",
                                  },
                                  backgroundColor: "#0077B5", // LinkedIn theme color
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  transition: "all 0.3s ease-in-out",
                                  "&:hover": {
                                    backgroundColor: "#005582", // Darker shade for hover
                                  },
                                }}
                              >
                                <LinkedInIcon
                                  sx={{
                                    fontSize: {
                                      xs: "25px",
                                      lg: "35px",
                                    },
                                    display: "flex",
                                    alignItems: "center",
                                    color: "#FFF",
                                  }}
                                />
                              </Box>
                            </Box>
                          )}
                          {userForm?.githubUrl && (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "flex-start",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Box
                                component="a"
                                href={`https://${userForm.githubUrl.replace(
                                  /^https?:\/\//,
                                  ""
                                )}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: {
                                    xs: "30px",
                                    lg: "40px",
                                  }, // Adjust as needed
                                  height: {
                                    xs: "30px",
                                    lg: "40px",
                                  },
                                  backgroundColor: "#333", // GitHub theme color
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  transition: "all 0.3s ease-in-out",
                                  "&:hover": {
                                    backgroundColor: "#444",
                                  },
                                }}
                              >
                                <GitHubIcon
                                  sx={{
                                    fontSize: {
                                      xs: "25px",
                                      lg: "35px",
                                    },
                                    display: "flex",
                                    alignItems: "center",
                                    color: "#FFF",
                                  }}
                                />
                              </Box>
                            </Box>
                          )}
                        </Box>
                      )}
                    </Box>
                    {uuid !== undefined && (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "flex-start",
                          justifyContent: "flex-end",
                        }}
                      >
                        <Box
                          component="div"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <RWebShare
                            data={{
                              text: "Here is something interesting for you.",
                              url: shareLink,
                              title: "Check this out!",
                            }}
                            onClick={() =>
                              console.log("shared successfully! public page")
                            }
                          >
                            <Button
                              variant="contained"
                              sx={{
                                backgroundColor: currentTheme.primary,
                                color: "#FDF9E0",
                                borderRadius: "5px",
                                padding: "0px !important",
                              }}
                            >
                              <ShareIcon
                                sx={{
                                  fontSize: {
                                    xs: "30px",
                                    lg: "40px",
                                  },
                                  padding: {
                                    xs: "2px",
                                    lg: "4px",
                                  },
                                }}
                              />
                            </Button>
                          </RWebShare>
                        </Box>
                      </Box>
                    )}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Splide
            options={{
              type: "loop",
              perPage: 1,
              perMove: 1,
              gap: "1rem",
              pagination: true,
              arrows: true, // Enable navigation arrows
              autoplay: false, // Disable autoplay
              speed: 600, // Animation speed
              breakpoints: {
                640: { gap: "0.5rem" }, // Mobile responsiveness
              },
            }}
            style={{
              padding: "1rem 0",
              position: "relative",
            }}
          >
            <SplideSlide>
              <Box sx={{ px: { xs: 2, sm: 3, md: 10 } }}>
                <Grid item xs={12}>
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                        border: "1px solid #FDF9E0",
                        borderRadius: "20px",
                        p: "10px",
                        minWidth: {
                          xs: "100%",
                          md: "100%",
                          lg: "90%",
                        },
                        maxWidth: {
                          xs: "100%",
                          md: "100%",
                          lg: "90%",
                        },
                        height: "500px",
                      }}
                    >
                      <Box sx={{ flex: 1, overflowY: "auto", padding: "10px" }}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "wrap",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "transparent",
                            color: "#FFF",
                            borderRadius: "12px",
                            width: "100%",
                          }}
                        >
                          <Grid container spacing={1}>
                            {/* Left Section: User Info */}
                            <Grid item xs={12} sm={12} md={12} lg={6}>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "14px",
                                }}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    gap: 1,
                                  }}
                                >
                                  {isValidName(userForm?.name) && (
                                    <Typography
                                      sx={{
                                        fontSize: {
                                          xs: "25px",
                                          md: "35px",
                                          lg: "40px",
                                        },
                                        fontWeight: 700,
                                        textAlign: { xs: "left", lg: "left" },
                                        lineHeight: {
                                          xs: "30px",
                                          md: "40px",
                                          lg: "50px",
                                        },
                                        color: "#FDF9E0",
                                        WebkitBackgroundClip: "text",
                                        backgroundClip: "text",
                                        flexGrow: 1,
                                        wordWrap: "break-word",
                                      }}
                                    >
                                      {`${userForm?.name?.trim()}`}
                                    </Typography>
                                  )}
                                </Box>

                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                  }}
                                >
                                  {isValidLocation(userForm?.location) && (
                                    <Box
                                      component="div"
                                      sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <Typography
                                        sx={{
                                          fontSize: { xs: "14px", lg: "22px" },
                                          textAlign: { xs: "left", lg: "left" },
                                          lineHeight: {
                                            xs: "16px",
                                            lg: "26px",
                                          },
                                          fontWeight: 500,
                                          color: "#FDF9E0",
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <LocationOnIcon
                                          sx={{
                                            fontSize: "inherit",
                                            color: currentTheme.primary,
                                            marginRight: "2px",
                                          }}
                                        />
                                        <Typography
                                          sx={{
                                            color: "#FDF9E0",
                                            fontSize: "inherit",
                                          }}
                                        >
                                          Work location:&nbsp;
                                        </Typography>
                                        {userForm?.location}
                                      </Typography>
                                    </Box>
                                  )}
                                </Box>

                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                  }}
                                >
                                  {userForm?.email && (
                                    <Typography
                                      sx={{
                                        fontSize: { xs: "14px", lg: "22px" },
                                        textAlign: { xs: "left", lg: "left" },
                                        lineHeight: {
                                          xs: "16px",
                                          lg: "26px",
                                        },
                                        fontWeight: 500,
                                        color: "#FDF9E0",
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <EmailIcon
                                        sx={{
                                          fontSize: "inherit",
                                          color: currentTheme.primary,
                                          marginRight: "2px",
                                        }}
                                      />
                                      <Typography
                                        sx={{
                                          color: "#FDF9E0",
                                          fontSize: "inherit",
                                        }}
                                      >
                                        Email:&nbsp;
                                      </Typography>
                                      {userForm?.email}
                                    </Typography>
                                  )}
                                </Box>
                                {userForm?.fileUrl && (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "flex-start",
                                      justifyContent: "flex-start",
                                    }}
                                  >
                                    <Box
                                      component="div"
                                      sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        mt: "4px",
                                      }}
                                    >
                                      <Link
                                        sx={{
                                          color: currentTheme.primary,
                                          fontSize: { xs: "14px", lg: "22px" },
                                          lineHeight: {
                                            xs: "16px",
                                            lg: "26px",
                                          },
                                          fontWeight: 500,
                                          display: "flex",
                                          alignItems: "center",
                                          textDecorationColor:
                                            currentTheme.primary,
                                        }}
                                        href={userForm?.fileUrl} // ✅ Use dynamic resume file URL
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        View Resume
                                        <OpenInNewIcon
                                          sx={{
                                            fontSize: "large",
                                            width: {
                                              xs: "12px",
                                              lg: "22px",
                                            },
                                            height: {
                                              xs: "12px",
                                              lg: "22px",
                                            },
                                            color: currentTheme.primary,
                                            ml: "5px",
                                          }}
                                        />
                                      </Link>
                                    </Box>
                                  </Box>
                                )}
                              </Box>
                              <Box
                                sx={{
                                  display: {
                                    xs: "none",
                                    md: "none",
                                    lg: "block",
                                  },
                                }}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    flexWrap: "wrap",
                                    alignItems: "center",
                                    justifyContent: "flex-start",
                                    color: "#FFF",
                                    borderRadius: "12px",
                                    mt: "55px",
                                    width: "100%",
                                  }}
                                >
                                  {/* Left Section: User Info */}
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "row",
                                      gap: 1,
                                    }}
                                  >
                                    {publicResult.evaluationTested ? (
                                      <img
                                        src="/assets/images/peerreviewed.svg"
                                        alt="Evaluation Tested"
                                        style={{
                                          maxWidth: isMobile
                                            ? "100px"
                                            : isTablet
                                            ? "100px"
                                            : "120px",
                                        }}
                                        loading="lazy"
                                      />
                                    ) : publicResult.selfAttested ? (
                                      <img
                                        src="/assets/images/SELF-ATTESTED.svg"
                                        alt="Self Attested"
                                        style={{
                                          maxWidth: isMobile
                                            ? "100px"
                                            : isTablet
                                            ? "100px"
                                            : "120px",
                                        }}
                                        loading="lazy"
                                      />
                                    ) : publicResult.resumeParsed ? (
                                      <img
                                        src="/assets/images/ResumeBased.svg"
                                        alt="Resume Parsed"
                                        style={{
                                          maxWidth: isMobile
                                            ? "100px"
                                            : isTablet
                                            ? "100px"
                                            : "120px",
                                        }}
                                        loading="lazy"
                                      />
                                    ) : (
                                      "N/A"
                                    )}
                                  </Box>
                                </Box>
                              </Box>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={6}>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: 1,
                                }}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: {
                                      xs: "flex-start",
                                      sm: "flex-start",
                                      md: "flex-start",
                                      lg: "center",
                                    },
                                  }}
                                >
                                  {(userForm?.githubUrl ||
                                    userForm?.linkedInUrl) && (
                                    <Box
                                      sx={{
                                        display: { xs: "flex", sm: "flex" },
                                        flexWrap: "wrap",
                                        alignItems: "center",
                                        mt: "10px",
                                        gap: 1,
                                      }}
                                    >
                                      {userForm?.linkedInUrl && (
                                        <Box
                                          sx={{
                                            display: "flex",
                                            alignItems: "flex-start",
                                            justifyContent: "flex-end",
                                          }}
                                        >
                                          <Box
                                            component="div"
                                            sx={{
                                              display: "flex",
                                              flexDirection: "column",
                                            }}
                                          >
                                            <Button
                                              sx={{
                                                background: "#0077B5",
                                                borderRadius: "10px !important",
                                                color: "#FFF",
                                                fontSize: {
                                                  xs: "15px",
                                                  lg: "22px",
                                                },
                                                fontWeight: 600,
                                                lineHeight: {
                                                  xs: "20px",
                                                  lg: "32px",
                                                },
                                                "& .MuiButton-endIcon": {
                                                  mr: "0px !important",
                                                },
                                                padding: "10px !important",
                                              }}
                                              href={`https://${userForm.linkedInUrl.replace(
                                                /^https?:\/\//,
                                                ""
                                              )}`}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              endIcon={<OpenInNewIcon />}
                                            >
                                              <LinkedInIcon
                                                sx={{
                                                  fontSize: "large",
                                                  width: {
                                                    xs: "20px",
                                                    lg: "30px",
                                                  },
                                                  height: {
                                                    xs: "20px",
                                                    lg: "30px",
                                                  },
                                                  color: "#fff",
                                                  marginRight: "5px",
                                                }}
                                              />
                                              LinkedIn
                                            </Button>
                                          </Box>
                                        </Box>
                                      )}
                                      {userForm?.githubUrl && (
                                        <Box
                                          sx={{
                                            display: "flex",
                                            alignItems: "flex-start",
                                            justifyContent: "flex-end",
                                          }}
                                        >
                                          <Box
                                            component="div"
                                            sx={{
                                              display: "flex",
                                              flexDirection: "column",
                                            }}
                                          >
                                            <Button
                                              sx={{
                                                background: "#333",
                                                borderRadius: "10px !important",
                                                color: "#FFF",
                                                fontSize: {
                                                  xs: "15px",
                                                  lg: "22px",
                                                },
                                                fontWeight: 600,
                                                lineHeight: {
                                                  xs: "20px",
                                                  lg: "32px",
                                                },
                                                "& .MuiButton-endIcon": {
                                                  mr: "0px !important",
                                                },
                                                padding: "10px !important",
                                              }} // GitHub's color theme
                                              href={`https://${userForm.githubUrl.replace(
                                                /^https?:\/\//,
                                                ""
                                              )}`}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              endIcon={<OpenInNewIcon />}
                                            >
                                              <GitHubIcon
                                                sx={{
                                                  fontSize: "large",
                                                  width: {
                                                    xs: "20px",
                                                    lg: "30px",
                                                  },
                                                  height: {
                                                    xs: "20px",
                                                    lg: "30px",
                                                  },
                                                  color: "#fff",
                                                  marginRight: "5px",
                                                }}
                                              />
                                              GitHub
                                            </Button>
                                          </Box>
                                        </Box>
                                      )}
                                    </Box>
                                  )}
                                </Box>
                                {userForm?.experience && (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: {
                                        xs: "flex-start",
                                        sm: "flex-start",
                                        md: "flex-start",
                                        lg: "center",
                                      },
                                    }}
                                  >
                                    <Card
                                      sx={{
                                        border: `1px  dashed ${currentTheme.primary}`,
                                        borderRadius: "10px",
                                        boxShadow: "none",
                                        padding: "15px",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        marginTop: "10px",
                                        backgroundColor: currentTheme.secondary,
                                      }}
                                    >
                                      <CardContent
                                        sx={{ p: "0 !important", flexGrow: 1 }}
                                      >
                                        <Box
                                          sx={{
                                            display: "flex",
                                            flexWrap: "wrap",
                                            gap: 1,
                                          }}
                                        >
                                          <Typography
                                            variant="h4"
                                            sx={{
                                              fontWeight: 600,
                                              display: "flex",
                                              alignItems: "center",
                                              textAlign: "center",
                                              color: "#FDF9E0",
                                              // pl: { xs: 1, lg: 2 },
                                              fontSize: {
                                                xs: "15px",
                                                lg: "35px",
                                              },
                                              lineHeight: {
                                                xs: "20px",
                                                lg: "45px",
                                              },
                                            }}
                                          >
                                            {isNaN(userForm?.experience)
                                              ? `Total experience of ${userForm?.experience}`
                                              : (() => {
                                                  const totalMonths = parseInt(
                                                    userForm?.experience,
                                                    10
                                                  );

                                                  // Convert months to years and months
                                                  const years = Math.floor(
                                                    totalMonths / 12
                                                  );
                                                  const months =
                                                    totalMonths % 12;

                                                  // Build the experience string
                                                  let experienceText = "";
                                                  if (years > 0) {
                                                    experienceText += `${years} ${
                                                      years > 1
                                                        ? "Years"
                                                        : "Year"
                                                    }`;
                                                  }
                                                  if (months > 0) {
                                                    experienceText += ` ${months} ${
                                                      months > 1
                                                        ? "Months"
                                                        : "Month"
                                                    }`;
                                                  } else if (
                                                    totalMonths === 0
                                                  ) {
                                                    return `Fresher/Intern/Trainee`;
                                                  }
                                                  // if(months)

                                                  return `Total experience of ${experienceText}`;
                                                })()}
                                          </Typography>
                                        </Box>
                                      </CardContent>
                                    </Card>
                                  </Box>
                                )}
                                {uuid !== undefined && (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: {
                                        xs: "flex-start",
                                        sm: "flex-start",
                                        md: "flex-start",
                                        lg: "center",
                                      },
                                      marginTop: "10px",
                                    }}
                                  >
                                    <Box
                                      component="div"
                                      sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <RWebShare
                                        data={{
                                          text: "Here is something interesting for you.",
                                          url: shareLink,
                                          title: "Check this out!",
                                        }}
                                        onClick={() =>
                                          console.log(
                                            "shared successfully! public page"
                                          )
                                        }
                                      >
                                        <Button
                                          variant="contained"
                                          sx={{
                                            backgroundColor:
                                              currentTheme.primary,
                                            color: "#FFF",
                                            borderRadius: "8px",
                                            "&:hover": {
                                              backgroundColor:
                                                currentTheme.primary,
                                            },
                                            fontWeight: 700,
                                            fontSize: {
                                              xs: "20px",
                                              lg: "32px",
                                            },
                                            lineHeight: "100%",
                                            padding: "10px !important",
                                          }}
                                        >
                                          <ShareIcon
                                            sx={{
                                              marginRight: 1,
                                              fontSize: {
                                                xs: "20px",
                                                lg: "33px",
                                              },
                                            }}
                                          />{" "}
                                          Share
                                        </Button>
                                      </RWebShare>
                                    </Box>
                                  </Box>
                                )}
                              </Box>
                            </Grid>
                            <Box
                              sx={{
                                display: {
                                  xs: "block",
                                  md: "block",
                                  lg: "none",
                                },
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  flexWrap: "wrap",
                                  alignItems: "center",
                                  justifyContent: "flex-start",
                                  color: "#FFF",
                                  borderRadius: "12px",
                                  mt: "20px",
                                  ml: "10px",
                                  width: "100%",
                                }}
                              >
                                {/* Left Section: User Info */}
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 1,
                                  }}
                                >
                                  {publicResult.evaluationTested ? (
                                    <img
                                      src="/assets/images/peerreviewed.svg"
                                      alt="Evaluation Tested"
                                      style={{
                                        maxWidth: isMobile
                                          ? "100px"
                                          : isTablet
                                          ? "100px"
                                          : "120px",
                                      }}
                                      loading="lazy"
                                    />
                                  ) : publicResult.selfAttested ? (
                                    <img
                                      src="/assets/images/SELF-ATTESTED.svg"
                                      alt="Self Attested"
                                      style={{
                                        maxWidth: isMobile
                                          ? "100px"
                                          : isTablet
                                          ? "100px"
                                          : "120px",
                                      }}
                                      loading="lazy"
                                    />
                                  ) : publicResult.resumeParsed ? (
                                    <img
                                      src="/assets/images/ResumeBased.svg"
                                      alt="Resume Parsed"
                                      style={{
                                        maxWidth: isMobile
                                          ? "100px"
                                          : isTablet
                                          ? "100px"
                                          : "120px",
                                      }}
                                      loading="lazy"
                                    />
                                  ) : (
                                    "N/A"
                                  )}
                                </Box>
                              </Box>
                            </Box>
                          </Grid>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              </Box>
            </SplideSlide>
            {(skillsData?.primarySkill?.length !== 0 ||
              skillsData?.secondarySkill?.length !== 0) && (
              <SplideSlide>
                <Box sx={{ px: { xs: 2, sm: 3, md: 10 } }}>
                  <Grid item xs={12}>
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          flexDirection: "column",
                          border: `1px solid #FDF9E0`,
                          borderRadius: "20px",
                          p: "10px",
                          minWidth: {
                            xs: "100%",
                            md: "100%",
                            lg: "90%",
                          },
                          maxWidth: {
                            xs: "100%",
                            md: "100%",
                            lg:
                              resultData?.primarySkill?.length === 0
                                ? "100%"
                                : "90%",
                          },
                          height: "500px",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexShrink: 0,
                            mt: "10px",
                          }}
                        >
                          <Legend />
                        </Box>
                        <Box
                          sx={{ flex: 1, overflowY: "auto", padding: "10px" }}
                        >
                          <Grid container spacing={3} justifyContent="center">
                            {/* Experience Cards */}
                            <Grid
                              container
                              spacing={3}
                              sx={{ flexWrap: "wrap", m: "0px !important" }}
                            >
                              {skillsData?.primarySkill?.map((item, index) => {
                                return (
                                  item?.name?.length !== 0 && (
                                    <Grid
                                      xs={12}
                                      sm={6}
                                      md={4}
                                      lg={4}
                                      xl={3}
                                      item
                                      key={index}
                                    >
                                      <Paper
                                        sx={{
                                          border: `1px dashed ${
                                            item.skillBackgroundColor
                                              ? "#FDF9E0"
                                              : "#8DE49A"
                                          }`,
                                          borderRadius: "10px",
                                          display: "flex",
                                          boxShadow: "none",
                                          alignItems: "center",
                                          flexDirection: "column",
                                          height: "100%",
                                          backgroundColor:
                                            item.skillBackgroundColor || "#fff",
                                        }}
                                      >
                                        {/* Expiry Year Above Skill Name */}
                                        {item?.expiryYear && (
                                          <Typography
                                            sx={{
                                              fontSize: "14px",
                                              fontWeight: "bold",
                                              color: "#0F0D0E",
                                              my: 1,
                                            }}
                                          >
                                            Validity Until {item.expiryYear}
                                          </Typography>
                                        )}
                                        <Box
                                          sx={{
                                            borderTop: `1px dashed ${
                                              item.skillBackgroundColor
                                                ? "#FDF9E0"
                                                : "#8DE49A"
                                            }`,
                                            width: "100%",
                                          }}
                                        />
                                        <Box
                                          sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            flexDirection: "row",
                                            m: 0.2,
                                          }}
                                        >
                                          {item?.iconUrl ? (
                                            <Avatar
                                              src={item?.iconUrl}
                                              alt="Icons"
                                              sx={{
                                                width: "35px",
                                                height: "35px",
                                                p: "5px",
                                                ml: 1,
                                                backgroundColor: "#FDF9E0",
                                              }}
                                              slotProps={{
                                                img: {
                                                  loading: "lazy",
                                                },
                                              }}
                                            />
                                          ) : (
                                            <Avatar
                                              alt="Icon"
                                              sx={{
                                                width: 35,
                                                height: 35,
                                                p: "5px",
                                                ml: 1,
                                                fontSize: 13,
                                                backgroundColor: "#FDF9E0",
                                                color: "#616161",
                                              }}
                                            >
                                              {(() => {
                                                if (!item?.name) return "";

                                                const words = item.name
                                                  .split(" ")
                                                  .filter(
                                                    (word) => word.length > 0
                                                  );
                                                let abbreviation = "";

                                                const getFirstValidChar = (
                                                  word
                                                ) => {
                                                  for (
                                                    let i = 0;
                                                    i < word.length;
                                                    i++
                                                  ) {
                                                    const char = word
                                                      .charAt(i)
                                                      .toUpperCase();
                                                    if (
                                                      /^[a-zA-Z0-9]$/.test(char)
                                                    ) {
                                                      return char;
                                                    }
                                                  }
                                                  return "";
                                                };

                                                if (words.length === 1) {
                                                  // Single word: Get the first valid character of the word
                                                  abbreviation =
                                                    getFirstValidChar(words[0]);
                                                } else if (words.length === 2) {
                                                  // Two words: Combine the first valid character of each word
                                                  abbreviation = words
                                                    .map((word) =>
                                                      getFirstValidChar(word)
                                                    )
                                                    .join("");
                                                } else if (words.length === 3) {
                                                  // Three words: Combine the first valid character of each word
                                                  abbreviation = words
                                                    .map((word) =>
                                                      getFirstValidChar(word)
                                                    )
                                                    .join("");
                                                } else if (words.length > 3) {
                                                  // More than three words: Only use the first valid character of the first word
                                                  abbreviation =
                                                    getFirstValidChar(words[0]);
                                                }

                                                // Handle cases where abbreviation might still be empty (due to no valid characters)
                                                if (!abbreviation) {
                                                  abbreviation = words
                                                    .map((word) =>
                                                      getFirstValidChar(word)
                                                    )
                                                    .join("");
                                                }

                                                return abbreviation;
                                              })()}
                                            </Avatar>
                                          )}

                                          <Typography
                                            sx={{
                                              pt: 2,
                                              pl: 2,
                                              pr: 2,
                                              pb: 2,
                                              fontSize: {
                                                xs: "16px",
                                                md: "20px",
                                                lg: "20px",
                                              },
                                              fontWeight: 500,
                                              color:
                                                item.skillTextColor || "#000",
                                              wordBreak: "break-word",
                                            }}
                                          >
                                            {item?.name}
                                          </Typography>
                                        </Box>
                                      </Paper>
                                    </Grid>
                                  )
                                );
                              })}
                              {skillsData?.secondarySkill?.map(
                                (item, index) => {
                                  return (
                                    item?.name?.length !== 0 && (
                                      <Grid
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                        xl={3}
                                        item
                                        key={index}
                                      >
                                        <Paper
                                          sx={{
                                            border: `1px dashed ${
                                              item.skillBackgroundColor
                                                ? "#FDF9E0"
                                                : "#8DE49A"
                                            }`,
                                            borderRadius: "10px",
                                            display: "flex",
                                            boxShadow: "none",
                                            alignItems: "center",
                                            flexDirection: "column",
                                            height: "100%",
                                            backgroundColor:
                                              item.skillBackgroundColor ||
                                              "#fff",
                                          }}
                                        >
                                          {/* Expiry Year Above Skill Name */}
                                          {item?.expiryYear && (
                                            <Typography
                                              sx={{
                                                fontSize: "14px",
                                                fontWeight: "bold",
                                                color: "#0F0D0E",
                                                my: 1,
                                              }}
                                            >
                                              Validity Until {item.expiryYear}
                                            </Typography>
                                          )}
                                          <Box
                                            sx={{
                                              borderTop: `1px dashed ${
                                                item.skillBackgroundColor
                                                  ? "#FDF9E0"
                                                  : "#8DE49A"
                                              }`,
                                              width: "100%",
                                            }}
                                          />
                                          <Box
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              flexDirection: "row",
                                              m: 0.2,
                                            }}
                                          >
                                            {item?.iconUrl ? (
                                              <Avatar
                                                src={item?.iconUrl}
                                                alt="Icons"
                                                sx={{
                                                  width: "35px",
                                                  height: "35px",
                                                  p: "5px",
                                                  ml: 1,
                                                  backgroundColor: "#FDF9E0",
                                                }}
                                                slotProps={{
                                                  img: {
                                                    loading: "lazy",
                                                  },
                                                }}
                                              />
                                            ) : (
                                              <Avatar
                                                alt="Icon"
                                                sx={{
                                                  width: 35,
                                                  height: 35,
                                                  p: "5px",
                                                  ml: 1,
                                                  fontSize: 13,
                                                  backgroundColor: "#FDF9E0",
                                                  color: "#616161",
                                                }}
                                              >
                                                {(() => {
                                                  if (!item?.name) return "";

                                                  const words = item.name
                                                    .split(" ")
                                                    .filter(
                                                      (word) => word.length > 0
                                                    );
                                                  let abbreviation = "";

                                                  const getFirstValidChar = (
                                                    word
                                                  ) => {
                                                    for (
                                                      let i = 0;
                                                      i < word.length;
                                                      i++
                                                    ) {
                                                      const char = word
                                                        .charAt(i)
                                                        .toUpperCase();
                                                      if (
                                                        /^[a-zA-Z0-9]$/.test(
                                                          char
                                                        )
                                                      ) {
                                                        return char;
                                                      }
                                                    }
                                                    return "";
                                                  };

                                                  if (words.length === 1) {
                                                    // Single word: Get the first valid character of the word
                                                    abbreviation =
                                                      getFirstValidChar(
                                                        words[0]
                                                      );
                                                  } else if (
                                                    words.length === 2
                                                  ) {
                                                    // Two words: Combine the first valid character of each word
                                                    abbreviation = words
                                                      .map((word) =>
                                                        getFirstValidChar(word)
                                                      )
                                                      .join("");
                                                  } else if (
                                                    words.length === 3
                                                  ) {
                                                    // Three words: Combine the first valid character of each word
                                                    abbreviation = words
                                                      .map((word) =>
                                                        getFirstValidChar(word)
                                                      )
                                                      .join("");
                                                  } else if (words.length > 3) {
                                                    // More than three words: Only use the first valid character of the first word
                                                    abbreviation =
                                                      getFirstValidChar(
                                                        words[0]
                                                      );
                                                  }

                                                  // Handle cases where abbreviation might still be empty (due to no valid characters)
                                                  if (!abbreviation) {
                                                    abbreviation = words
                                                      .map((word) =>
                                                        getFirstValidChar(word)
                                                      )
                                                      .join("");
                                                  }

                                                  return abbreviation;
                                                })()}
                                              </Avatar>
                                            )}
                                            <Typography
                                              sx={{
                                                pt: 2,
                                                pl: 2,
                                                pr: 2,
                                                pb: 2,
                                                fontSize: {
                                                  xs: "16px",
                                                  md: "20px",
                                                  lg: "20px",
                                                },
                                                fontWeight: 500,
                                                color:
                                                  item.skillTextColor || "#000",
                                                wordBreak: "break-word",
                                              }}
                                            >
                                              {item?.name}
                                            </Typography>
                                          </Box>
                                        </Paper>
                                      </Grid>
                                    )
                                  );
                                }
                              )}
                            </Grid>
                          </Grid>
                        </Box>
                      </Box>
                    </Box>
                  </Grid>
                </Box>
              </SplideSlide>
            )}

            {(skillsData?.AIToolsList?.some((item) => item && item.name) ||
              skillsData?.softwareToolsList?.some(
                (item) => item && item.name
              )) && (
              <SplideSlide>
                <ToolsComponent />
              </SplideSlide>
            )}

            {professionalBackgroundData.some((section) =>
              isValidValue(userForm?.[section.key])
            ) && (
              <>
                {/* Slide for General Sections (excluding certificationList and domainArea) */}
                <SplideSlide>
                  <Box sx={{ px: { xs: 2, sm: 3, md: 10 } }}>
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          flexDirection: "column",
                          border: "1px solid #FDF9E0",
                          borderRadius: "20px",
                          padding: "10px",
                          minWidth: { xs: "100%", md: "100%", lg: "90%" },
                          maxWidth: {
                            xs: "100%",
                            md: "100%",
                            lg: "90%",
                          },
                          height: "500px",
                        }}
                      >
                        <Box
                          sx={{ flex: 1, overflowY: "auto", padding: "10px" }}
                        >
                          <Grid container spacing={3}>
                            {professionalBackgroundData
                              .filter(
                                (section) =>
                                  isValidValue(userForm?.[section.key]) &&
                                  section.key !== "certificationList" &&
                                  section.key !== "domainArea"
                              )
                              .map((subSections, index) => {
                                const item = professionalBackgroundData.find(
                                  (data) => data.key === subSections.key
                                );
                                if (!item) return null;

                                const value =
                                  userForm?.[item.key] ?? "Not Provided";
                                let displayValue;

                                if (typeof value === "string") {
                                  const splitValue =
                                    value.match(/^(.*?)\s*\((.*?)\)$/);
                                  displayValue = splitValue ? (
                                    <>
                                      <Typography>
                                        {splitValue[1].trim()}
                                      </Typography>
                                      <Typography>
                                        ({splitValue[2].trim()})
                                      </Typography>
                                    </>
                                  ) : (
                                    value
                                  );
                                } else if (Array.isArray(value)) {
                                  displayValue = value.map((v) => v.name || v);
                                } else if (
                                  typeof value === "object" &&
                                  value !== null
                                ) {
                                  displayValue =
                                    value?.name ||
                                    value?.certificatePopularName ||
                                    "Not Provided";
                                }

                                return (
                                  <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={4}
                                    lg={4}
                                    xl={3}
                                    key={index}
                                  >
                                    <Box
                                      sx={{
                                        position: "relative",
                                        textAlign: "center",
                                        zIndex: 1,
                                      }}
                                    >
                                      <Typography
                                        sx={{
                                          display: "inline-block",
                                          background: "#FDF9E0",
                                          color: "#000",
                                          fontWeight: "bold",
                                          fontSize: "14px",
                                          px: "25px",
                                          py: "6px",
                                          borderTopLeftRadius: "10px",
                                          borderTopRightRadius: "10px",
                                        }}
                                      >
                                        {subSections.name}
                                      </Typography>
                                    </Box>
                                    <Card
                                      sx={{
                                        border: "1px solid #FDF9E0",
                                        borderRadius: "10px",
                                        boxShadow: "none",
                                        padding: "15px",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        height: "180px",
                                      }}
                                    >
                                      <DynamicIcon defaultIcon={item.icon} />
                                      <CardContent
                                        sx={{
                                          p: "0 !important",
                                          flexGrow: 1,
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <Typography
                                          variant="body1"
                                          sx={{
                                            fontSize: "16px",
                                            fontWeight: 400,
                                            lineHeight: "26px",
                                            textAlign: "center",
                                          }}
                                        >
                                          {displayValue}
                                        </Typography>
                                      </CardContent>
                                    </Card>
                                  </Grid>
                                );
                              })}
                          </Grid>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </SplideSlide>

                {/* Slide for certificationList and domainArea */}
                {(isValidValue(userForm?.certificationList) ||
                  isValidValue(userForm?.domainArea)) && (
                  <SplideSlide>
                    <Box sx={{ px: { xs: 2, sm: 3, md: 10 } }}>
                      <Box sx={{ display: "flex", justifyContent: "center" }}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column",
                            border: "1px solid #FDF9E0",
                            borderRadius: "20px",
                            padding: "10px",
                            minWidth: { xs: "100%", md: "100%", lg: "90%" },
                            maxWidth: {
                              xs: "100%",
                              md: "100%",
                              lg: "90%",
                            },
                            height: "500px",
                          }}
                        >
                          <Box
                            sx={{ flex: 1, overflowY: "auto", padding: "10px" }}
                          >
                            <Grid
                              container
                              spacing={3}
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              {["certificationList", "domainArea"].map(
                                (key, index) => {
                                  const item = professionalBackgroundData.find(
                                    (data) => data.key === key
                                  );
                                  if (!item || !isValidValue(userForm?.[key]))
                                    return null;

                                  const value = userForm?.[key] ?? [];

                                  return (
                                    <Grid
                                      item
                                      xs={12}
                                      sm={6}
                                      md={6}
                                      key={index}
                                    >
                                      <Box
                                        sx={{
                                          position: "relative",
                                          textAlign: "center",
                                          zIndex: 1,
                                        }}
                                      >
                                        <Typography
                                          sx={{
                                            display: "inline-block",
                                            background: "#FDF9E0",
                                            color: "#000",
                                            fontWeight: "bold",
                                            fontSize: "14px",
                                            px: "25px",
                                            py: "6px",
                                            borderTopLeftRadius: "10px",
                                            borderTopRightRadius: "10px",
                                          }}
                                        >
                                          {item.name}
                                        </Typography>
                                      </Box>
                                      <Card
                                        sx={{
                                          border: "1px solid #FDF9E0",
                                          borderRadius: "10px",
                                          boxShadow: "none",
                                          padding: "15px",
                                          display: "flex",
                                          flexDirection: "column",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        <DynamicIcon defaultIcon={item.icon} />
                                        <CardContent
                                          sx={{
                                            p: "0 !important",
                                            flexGrow: 1,
                                          }}
                                        >
                                          <Box
                                            sx={{
                                              display: "flex",
                                              flexWrap: "wrap",
                                              justifyContent: "center",
                                              gap: 1,
                                            }}
                                          >
                                            {Array.isArray(value) &&
                                              value.map((entry, entryIndex) => (
                                                <Typography
                                                  key={entryIndex}
                                                  sx={{
                                                    mt: "10px",
                                                    fontSize: "15px",
                                                    fontWeight: 600,
                                                    padding: "4px 8px",
                                                    borderRadius: "5px",
                                                    backgroundColor:
                                                      "transparent",
                                                    border: "1px solid #000",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  {entry?.name || entry}
                                                </Typography>
                                              ))}
                                          </Box>
                                        </CardContent>
                                      </Card>
                                    </Grid>
                                  );
                                }
                              )}
                            </Grid>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </SplideSlide>
                )}
              </>
            )}

            {Array.isArray(userForm?.education) &&
              userForm?.education.length > 0 && (
                <SplideSlide>
                  <Box
                    sx={{
                      px: { xs: 2, sm: 3, md: 10 },
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                        border: "1px solid #FDF9E0",
                        borderRadius: "20px",
                        p: "10px",
                        minWidth: { xs: "100%", md: "100%", lg: "90%" },
                        maxWidth: {
                          xs: "100%",
                          md: "100%",
                          lg:
                            resultData?.education?.length === 0
                              ? "100%"
                              : "90%",
                        },
                        height: "500px",
                      }}
                    >
                      <Box
                        sx={{
                          flex: 1,
                          overflowY: "auto",
                          padding: "10px",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                            mb: "32px",
                          }}
                        >
                          <SchoolIcon
                            sx={{
                              height: {
                                xs: "25px",
                                md: "30px",
                              },
                              width: {
                                xs: "25px",
                                md: "30px",
                              },
                              fontSize: "large",
                              color: "#FDF9E0",
                            }}
                            alt="SchoolIcon"
                          />
                          <Typography
                            variant="h4"
                            sx={{
                              fontWeight: 600,
                              pl: { xs: 1, lg: 2 },
                              fontFamily: "Kanit",
                              fontSize: {
                                xs: "20px",
                                md: "30px",
                              },
                              textAlign: "center",
                              color: "#FDF9E0",
                            }}
                          >
                            Educational Qualification
                          </Typography>
                        </Box>
                        <Grid container spacing={3} justifyContent={"center"}>
                          {userForm.education.map((edu, index) => (
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              md={4}
                              lg={4}
                              xl={3}
                              key={index}
                            >
                              <Paper
                                sx={{
                                  border: "1px solid #FDF9E0",
                                  backgroundColor: "transparent",
                                  borderRadius: "10px",
                                  display: "flex",
                                  flexDirection: "column",
                                  boxShadow: "none",
                                  justifyContent: "center",
                                  padding: "12px",
                                  color: "#FDF9E0",
                                }}
                              >
                                {edu.institution && (
                                  <Typography
                                    sx={{
                                      fontSize: {
                                        xs: "16px",
                                        md: "20px",
                                        lg: "20px",
                                      },
                                      fontWeight: 300,
                                    }}
                                  >
                                    <strong>Institution : </strong>
                                    {edu.institution}
                                  </Typography>
                                )}
                                {edu.type && (
                                  <Typography
                                    sx={{
                                      fontSize: {
                                        xs: "16px",
                                        md: "20px",
                                        lg: "20px",
                                      },
                                      fontWeight: 300,
                                    }}
                                  >
                                    <strong>Type : </strong>
                                    {edu.type}
                                  </Typography>
                                )}
                                {edu.fieldOfStudy && (
                                  <Typography
                                    sx={{
                                      fontSize: {
                                        xs: "16px",
                                        md: "20px",
                                        lg: "20px",
                                      },
                                      fontWeight: 300,
                                    }}
                                  >
                                    <strong>Field of Study : </strong>
                                    {edu.fieldOfStudy}
                                  </Typography>
                                )}
                                {edu.location && (
                                  <Typography
                                    sx={{
                                      fontSize: {
                                        xs: "16px",
                                        md: "20px",
                                        lg: "20px",
                                      },
                                      fontWeight: 300,
                                    }}
                                  >
                                    <strong>Location : </strong>
                                    {edu.location}
                                  </Typography>
                                )}
                                {edu.duration && (
                                  <Typography
                                    sx={{
                                      fontSize: {
                                        xs: "16px",
                                        md: "20px",
                                        lg: "20px",
                                      },
                                      fontWeight: 300,
                                    }}
                                  >
                                    <strong>Duration : </strong>
                                    {edu.duration}
                                  </Typography>
                                )}
                                {edu.percentageOrGPA && (
                                  <Typography
                                    sx={{
                                      fontSize: {
                                        xs: "16px",
                                        md: "20px",
                                        lg: "20px",
                                      },
                                      fontWeight: 300,
                                    }}
                                  >
                                    <strong>Percentage/GPA : </strong>
                                    {edu.percentageOrGPA}
                                  </Typography>
                                )}
                              </Paper>
                            </Grid>
                          ))}
                        </Grid>
                      </Box>
                    </Box>
                  </Box>
                </SplideSlide>
              )}

            {((Array.isArray(userForm?.workActivities) &&
              userForm.workActivities.length > 0) ||
              (Array.isArray(userForm?.workExperience) &&
                userForm.workExperience.length > 0)) && (
              <SplideSlide>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    px: { xs: 2, sm: 3, md: 10 },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      border: "1px solid #FDF9E0",
                      borderRadius: "20px",
                      p: "10px",
                      minWidth: { xs: "100%", md: "100%", lg: "90%" },
                      maxWidth: {
                        xs: "100%",
                        md: "100%",
                        lg: "90%",
                      },
                      height: "500px",
                    }}
                  >
                    <Box sx={{ flex: 1, overflowY: "auto", padding: "10px" }}>
                      <Grid item xs={12}>
                        {Array.isArray(userForm?.workExperience) &&
                          userForm.workExperience.length > 0 && (
                            <>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  mb: "32px",
                                }}
                              >
                                <WorkIcon
                                  sx={{
                                    height: {
                                      xs: "25px",
                                      md: "30px",
                                    },
                                    width: {
                                      xs: "25px",
                                      md: "30px",
                                    },
                                    fontSize: "large",
                                    color: "#FDF9E0",
                                  }}
                                  alt="WorkIcon"
                                />
                                <Typography
                                  variant="h4"
                                  sx={{
                                    fontWeight: 600,
                                    pl: { xs: 1, lg: 2 },
                                    textAlign: "center",
                                    fontFamily: "Kanit",
                                    fontSize: {
                                      xs: "20px",
                                      md: "30px",
                                    },
                                    color: "#FDF9E0",
                                  }}
                                >
                                  Work Experience
                                </Typography>
                              </Box>
                              <Grid
                                container
                                spacing={3}
                                justifyContent={"center"}
                              >
                                {userForm?.workExperience?.map((exp, index) => (
                                  <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={4}
                                    lg={4}
                                    xl={3}
                                    key={index}
                                  >
                                    <Paper
                                      sx={{
                                        border: "1px solid #FDF9E0",
                                        backgroundColor: "transparent",
                                        borderRadius: "10px",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        boxShadow: "none",
                                        padding: "14px",
                                      }}
                                    >
                                      {exp.role && (
                                        <Typography
                                          variant="h6"
                                          color="#FDF9E0"
                                          sx={{
                                            fontWeight: 600,
                                            fontSize: "18px",
                                          }}
                                        >
                                          {exp.role}
                                        </Typography>
                                      )}
                                      {exp.company && (
                                        <Typography
                                          sx={{
                                            color: "rgba(253, 249, 224, 0.6)",
                                            fontSize: "14px",
                                          }}
                                        >
                                          {exp.company}
                                        </Typography>
                                      )}
                                      {exp.location && (
                                        <Typography
                                          color="#FDF9E0"
                                          sx={{
                                            fontStyle: "italic",
                                            fontSize: "14px",
                                          }}
                                        >
                                          {exp.location}
                                        </Typography>
                                      )}
                                      {exp.duration && (
                                        <Typography
                                          sx={{
                                            color: currentTheme.primary,
                                            fontSize: "14px",
                                          }}
                                        >
                                          {exp.duration}
                                        </Typography>
                                      )}
                                    </Paper>
                                  </Grid>
                                ))}
                              </Grid>
                            </>
                          )}
                        {Array.isArray(userForm?.workActivities) &&
                          userForm.workActivities.length > 0 && (
                            <>
                              {/* Header with Icon */}
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  mt: 3,
                                  mb: "32px",
                                }}
                              >
                                <WorkIcon
                                  sx={{
                                    height: {
                                      xs: "25px",
                                      md: "30px",
                                    },
                                    width: {
                                      xs: "25px",
                                      md: "30px",
                                    },
                                    fontSize: "large",
                                    color: "#FDF9E0",
                                  }}
                                  alt="WorkIcon"
                                />
                                <Typography
                                  variant="h4"
                                  sx={{
                                    fontWeight: 600,
                                    pl: { xs: 1, lg: 2 },
                                    textAlign: "center",
                                    fontFamily: "Kanit",
                                    fontSize: {
                                      xs: "20px",
                                      md: "30px",
                                    },
                                    color: "#FDF9E0",
                                  }}
                                >
                                  Work Activities
                                </Typography>
                              </Box>
                              {/* Work Activities List */}
                              <Grid
                                container
                                spacing={3}
                                justifyContent={"center"}
                              >
                                {userForm.workActivities.map(
                                  (activity, index) => (
                                    <Grid
                                      item
                                      xs={12}
                                      sm={6}
                                      md={4}
                                      lg={4}
                                      xl={3}
                                      key={index}
                                    >
                                      <Paper
                                        sx={{
                                          border: "1px solid #FDF9E0",
                                          backgroundColor: "transparent",
                                          borderRadius: "10px",
                                          display: "flex",
                                          boxShadow: "none",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Typography
                                          sx={{
                                            p: 2,
                                            fontSize: {
                                              xs: "16px",
                                              md: "20px",
                                              lg: "20px",
                                            },
                                            color: "#FDF9E0",
                                            textAlign: "center",
                                          }}
                                        >
                                          {activity}
                                        </Typography>
                                      </Paper>
                                    </Grid>
                                  )
                                )}
                              </Grid>
                            </>
                          )}
                      </Grid>
                    </Box>
                  </Box>
                </Box>
              </SplideSlide>
            )}

            {((Array.isArray(userForm?.projects) &&
              userForm.projects.length > 0) ||
              (Array.isArray(userForm?.achievements) &&
                userForm.achievements.length > 0)) && (
              <SplideSlide>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    px: { xs: 2, sm: 3, md: 10 },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      border: "1px solid #FDF9E0",
                      borderRadius: "20px",
                      p: "10px",
                      minWidth: { xs: "100%", md: "100%", lg: "90%" },
                      maxWidth: {
                        xs: "100%",
                        md: "100%",
                        lg: "90%",
                      },
                      height: "500px",
                    }}
                  >
                    <Box sx={{ flex: 1, overflowY: "auto", padding: "10px" }}>
                      <Grid item xs={12}>
                        {Array.isArray(userForm?.projects) &&
                          userForm.projects.length > 0 && (
                            <>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  mb: "32px",
                                }}
                              >
                                <Projects
                                  sx={{
                                    height: {
                                      xs: "25px",
                                      md: "30px",
                                    },
                                    width: {
                                      xs: "25px",
                                      md: "30px",
                                    },
                                    fontSize: "large",
                                    color: "#FDF9E0",
                                  }}
                                  alt="Projects"
                                />
                                <Typography
                                  variant="h4"
                                  sx={{
                                    fontWeight: 600,
                                    pl: { xs: 1, lg: 2 },
                                    fontFamily: "Kanit",
                                    fontSize: {
                                      xs: "20px",
                                      md: "30px",
                                    },
                                    textAlign: "center",
                                    color: "#FDF9E0",
                                  }}
                                >
                                  Projects
                                </Typography>
                              </Box>
                              <Grid
                                container
                                spacing={3}
                                justifyContent={"center"}
                              >
                                {userForm.projects.map((projects, index) => (
                                  <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={4}
                                    lg={4}
                                    xl={3}
                                    key={index}
                                  >
                                    <Paper
                                      sx={{
                                        border: "1px solid #FDF9E0",
                                        backgroundColor: "transparent",
                                        borderRadius: "10px",
                                        display: "flex",
                                        boxShadow: "none",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <Typography
                                        sx={{
                                          p: 2,
                                          fontSize: {
                                            xs: "16px",
                                            md: "20px",
                                            lg: "20px",
                                          },
                                          textAlign: "center",
                                          color: "#FDF9E0",
                                        }}
                                      >
                                        {projects}
                                      </Typography>
                                    </Paper>
                                  </Grid>
                                ))}
                              </Grid>
                            </>
                          )}
                        {Array.isArray(userForm?.achievements) &&
                          userForm.achievements.length > 0 && (
                            <>
                              {/* Header with Icon */}
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  mt: 3,
                                  mb: "32px",
                                }}
                              >
                                <Achievements
                                  sx={{
                                    height: {
                                      xs: "25px",
                                      md: "30px",
                                    },
                                    width: {
                                      xs: "25px",
                                      md: "30px",
                                    },
                                    fontSize: "large",
                                    color: "#FDF9E0",
                                  }}
                                />
                                <Typography
                                  variant="h4"
                                  sx={{
                                    fontWeight: 600,
                                    pl: { xs: 1, lg: 2 },
                                    fontFamily: "Kanit",
                                    fontSize: {
                                      xs: "20px",
                                      md: "30px",
                                    },
                                    textAlign: "center",
                                    color: "#FDF9E0",
                                  }}
                                >
                                  Achievements
                                </Typography>
                              </Box>
                              {/* Achievements */}
                              <Grid
                                container
                                spacing={3}
                                justifyContent={"center"}
                              >
                                {userForm.achievements.map(
                                  (achievements, index) => (
                                    <Grid
                                      item
                                      xs={12}
                                      sm={6}
                                      md={4}
                                      lg={4}
                                      xl={3}
                                      key={index}
                                    >
                                      <Paper
                                        sx={{
                                          border: "1px solid #FDF9E0",
                                          backgroundColor: "transparent",
                                          borderRadius: "10px",
                                          display: "flex",
                                          boxShadow: "none",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Typography
                                          sx={{
                                            p: 2,
                                            fontSize: {
                                              xs: "16px",
                                              md: "20px",
                                              lg: "20px",
                                            },
                                            color: "#FDF9E0",
                                            textAlign: "center",
                                          }}
                                        >
                                          {achievements}
                                        </Typography>
                                      </Paper>
                                    </Grid>
                                  )
                                )}
                              </Grid>
                            </>
                          )}
                      </Grid>
                    </Box>
                  </Box>
                </Box>
              </SplideSlide>
            )}

            {((Array.isArray(userForm?.languages) &&
              userForm?.languages.length > 0) ||
              (Array.isArray(userForm?.hobbies_interests) &&
                userForm?.hobbies_interests.length > 0)) && (
              <SplideSlide>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    px: { xs: 2, sm: 3, md: 10 },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      border: "1px solid #FDF9E0",
                      borderRadius: "20px",
                      p: "10px",
                      minWidth: { xs: "100%", md: "100%", lg: "90%" },
                      maxWidth: {
                        xs: "100%",
                        md: "100%",
                        lg: "90%",
                      },
                      height: "500px",
                    }}
                  >
                    <Box sx={{ flex: 1, overflowY: "auto", padding: "10px" }}>
                      {Array.isArray(userForm?.languages) &&
                        userForm?.languages?.length > 0 && (
                          <>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center",
                                alignItems: "center",
                                mb: "32px",
                              }}
                            >
                              <LanguageIcon
                                sx={{
                                  height: {
                                    xs: "25px",
                                    md: "30px",
                                  },
                                  width: {
                                    xs: "25px",
                                    md: "30px",
                                  },
                                  fontSize: "large",
                                  color: "#FDF9E0",
                                }}
                                alt="LanguageIcon"
                              />
                              <Typography
                                variant="h4"
                                sx={{
                                  fontWeight: 600,
                                  pl: { xs: 1, lg: 2 },
                                  fontFamily: "Kanit",
                                  fontSize: {
                                    xs: "20px",
                                    md: "30px",
                                  },
                                  textAlign: "center",
                                  color: "#FDF9E0",
                                }}
                              >
                                Languages
                              </Typography>
                            </Box>
                            <Grid
                              container
                              spacing={3}
                              justifyContent={"center"}
                            >
                              {userForm?.languages.map((item, index) => (
                                <Grid
                                  item
                                  xs={12}
                                  sm={6}
                                  md={4}
                                  lg={4}
                                  xl={3}
                                  key={index}
                                >
                                  <Paper
                                    sx={{
                                      border: "1px solid #FDF9E0",
                                      backgroundColor: "transparent",
                                      borderRadius: "10px",
                                      display: "flex",
                                      boxShadow: "none",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        p: 2,
                                        fontSize: {
                                          xs: "16px",
                                          md: "20px",
                                          lg: "20px",
                                        },
                                        textAlign: "center",
                                        color: "#FDF9E0",
                                      }}
                                    >
                                      {item}
                                    </Typography>
                                  </Paper>
                                </Grid>
                              ))}
                            </Grid>
                          </>
                        )}

                      {Array.isArray(userForm?.hobbies_interests) &&
                        userForm.hobbies_interests.length > 0 && (
                          <>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center",
                                alignItems: "center",
                                mt: 3,
                                mb: "32px",
                              }}
                            >
                              <LocalActivityIcon
                                sx={{
                                  height: {
                                    xs: "25px",
                                    md: "30px",
                                  },
                                  width: {
                                    xs: "25px",
                                    md: "30px",
                                  },
                                  fontSize: "large",
                                  color: "#FDF9E0",
                                }}
                                alt="LocalActivityIcon"
                              />
                              <Typography
                                variant="h4"
                                sx={{
                                  fontWeight: 600,
                                  pl: { xs: 1, lg: 2 },
                                  fontFamily: "Kanit",
                                  fontSize: {
                                    xs: "20px",
                                    md: "30px",
                                  },
                                  textAlign: "center",
                                  color: "#FDF9E0",
                                }}
                              >
                                Hobbies & Interests
                              </Typography>
                            </Box>
                            <Grid
                              container
                              spacing={3}
                              justifyContent={"center"}
                            >
                              {userForm?.hobbies_interests.map(
                                (item, index) => (
                                  <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={4}
                                    lg={4}
                                    xl={3}
                                    key={index}
                                  >
                                    <Paper
                                      sx={{
                                        border: "1px solid #FDF9E0",
                                        backgroundColor: "transparent",
                                        borderRadius: "10px",
                                        display: "flex",
                                        boxShadow: "none",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <Typography
                                        sx={{
                                          p: 2,
                                          fontSize: {
                                            xs: "16px",
                                            md: "20px",
                                            lg: "20px",
                                          },
                                          textAlign: "center",
                                          color: "#FDF9E0",
                                        }}
                                      >
                                        {item}
                                      </Typography>
                                    </Paper>
                                  </Grid>
                                )
                              )}
                            </Grid>
                          </>
                        )}
                    </Box>
                  </Box>
                </Box>
              </SplideSlide>
            )}

            {hasFilledValues && (
              <SplideSlide>
                <Box sx={{ px: { xs: 2, sm: 3, md: 10 } }}>
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <Box
                      sx={{
                        minWidth: { xs: "100%", md: "100%", lg: "90%" },
                        maxWidth: { xs: "100%", md: "100%", lg: "90%" },
                      }}
                    >
                      <Card
                        sx={{
                          p: "10px",
                          backgroundColor: "transparent",
                          border: "1px solid #FDF9E0",
                          borderRadius: "10px",
                          height: "500px", // Fixed height for the card
                          overflowY: "auto", // Enable vertical scrolling
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <Box
                          sx={{
                            flexGrow: 1,
                            overflowY: "auto",
                            padding: "10px",
                          }}
                        >
                          <CardContent
                            sx={{
                              p: "0px !important",
                              flexShrink: 0, // Prevent the header from shrinking
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center",
                                alignItems: "center",
                                mb: "10px",
                              }}
                            >
                              <AssignmentTurnedInIcon
                                sx={{
                                  height: {
                                    xs: "25px",
                                    md: "30px",
                                  },
                                  width: {
                                    xs: "25px",
                                    md: "30px",
                                  },
                                  fontSize: "large",
                                  color: "#FDF9E0",
                                }}
                                alt="AssignmentTurnedInIcon"
                              />
                              <Typography
                                variant="h6"
                                sx={{
                                  fontWeight: 600,
                                  pl: { xs: 1, lg: 2 },
                                  fontFamily: "Kanit",
                                  fontSize: {
                                    xs: "20px",
                                    md: "30px",
                                  },
                                  textAlign: "center",
                                  color: "#FDF9E0",
                                }}
                              >
                                Considered Factors for Salary Calculation
                              </Typography>
                            </Box>

                            <Typography
                              variant="body1"
                              sx={{
                                fontWeight: 400,
                                fontSize: {
                                  xs: "12px",
                                  md: "18px",
                                },
                                textAlign: "center",
                                color: "#FDF9E0",
                              }}
                            >
                              Your salary calculation is based on the following
                              factors:
                            </Typography>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                my: 3,
                              }}
                            >
                              <Button
                                variant="contained"
                                sx={{
                                  backgroundColor: currentTheme.primary,
                                  textAlign: "center",
                                  borderRadius: "10px",
                                  fontWeight: {
                                    xs: 500,
                                    md: 700,
                                  },
                                  fontSize: {
                                    xs: "14px",
                                    md: "20px",
                                  },
                                  color: "#FDF9E0",
                                }}
                                target="_blank"
                                rel="noopener noreferrer"
                                href={`${process.env.REACT_APP_TECHWORTH_URL}`}
                              >
                                Change Factors using TrueSelfy TechWorth
                              </Button>
                            </Box>
                          </CardContent>
                          <Grid container spacing={3}>
                            {filledFields.map(({ name, key, icon }) => (
                              <Grid
                                item
                                xs={12}
                                sm={6}
                                md={4}
                                lg={4}
                                xl={3}
                                key={key}
                              >
                                <Box
                                  sx={{
                                    position: "relative",
                                    textAlign: "center",
                                    zIndex: 1,
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      display: "inline-block",
                                      background: "#FDF9E0",
                                      color: "#000",
                                      fontWeight: "bold",
                                      fontSize: "14px",
                                      px: "25px",
                                      py: "6px",
                                      borderTopLeftRadius: "10px",
                                      borderTopRightRadius: "10px",
                                    }}
                                  >
                                    {name}
                                  </Typography>
                                </Box>
                                <Card
                                  sx={{
                                    backgroundColor: "#231F20",
                                    borderRadius: "10px",
                                    boxShadow: "none",
                                    padding: "15px",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <CardContent
                                    sx={{
                                      p: "0 !important",
                                      flexGrow: 1,
                                      color: "#FDF9E0",
                                    }}
                                  >
                                    <Typography
                                      variant="body1"
                                      sx={{
                                        fontSize: {
                                          xs: "14px",
                                          md: "16px",
                                        },
                                        fontWeight: 500,
                                        textAlign: "center",
                                      }}
                                    >
                                      {String(userFormData[key])}
                                    </Typography>
                                  </CardContent>
                                </Card>
                              </Grid>
                            ))}
                          </Grid>
                        </Box>
                      </Card>
                    </Box>
                  </Box>
                </Box>
              </SplideSlide>
            )}

            {/* Final Slide - Missing Fields */}
            {hasMissingFields && (
              <SplideSlide>
                <Box sx={{ px: { xs: 2, sm: 3, md: 10 } }}>
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <Box
                      sx={{
                        minWidth: { xs: "100%", md: "100%", lg: "90%" },
                        maxWidth: { xs: "100%", md: "100%", lg: "90%" },
                      }}
                    >
                      <Card
                        sx={{
                          p: "10px",
                          backgroundColor: "transparent",
                          border: "1px solid #FDF9E0",
                          borderRadius: "10px",
                          height: "500px", // Fixed height for the card
                          overflowY: "auto", // Enable vertical scrolling
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <Box
                          sx={{
                            flexGrow: 1,
                            overflowY: "auto",
                            padding: "10px",
                          }}
                        >
                          <CardContent sx={{ p: "0 !important", flexGrow: 1 }}>
                            {/* Header Section */}
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center",
                                alignItems: "center",
                                mb: "10px",
                              }}
                            >
                              <PriorityHighIcon
                                sx={{
                                  fontSize: "large",
                                  height: {
                                    xs: "25px",
                                    md: "30px",
                                  },
                                  width: {
                                    xs: "25px",
                                    md: "30px",
                                  },
                                  color: "#E0011C",
                                }}
                                alt="PriorityHighIcon"
                              />
                              <Typography
                                variant="h6"
                                sx={{
                                  fontWeight: 600,
                                  pl: { xs: 1, lg: 2 },
                                  fontFamily: "Kanit",
                                  fontSize: {
                                    xs: "20px",
                                    md: "30px",
                                  },
                                  textAlign: "center",
                                  color: "#E0011C",
                                }}
                              >
                                Missing Information
                              </Typography>
                            </Box>

                            {/* Description */}
                            <Typography
                              variant="body1"
                              sx={{
                                fontWeight: 400,
                                fontSize: {
                                  xs: "12px",
                                  md: "18px",
                                },
                                textAlign: "center",
                                color: "#E0011C",
                              }}
                            >
                              To get the most accurate TechWorth estimation,
                              please complete the missing fields:
                            </Typography>

                            {/* Button to Complete Profile */}
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                my: 3,
                              }}
                            >
                              <Button
                                variant="contained"
                                sx={{
                                  backgroundColor: currentTheme.primary,
                                  textAlign: "center",
                                  color: "#FDF9E0",
                                  borderRadius: "10px",
                                  fontWeight: {
                                    xs: 500,
                                    md: 700,
                                  },
                                  fontSize: {
                                    xs: "14px",
                                    md: "20px",
                                  },
                                }}
                                color="primary"
                                target="_blank"
                                rel="noopener noreferrer"
                                href={`${process.env.REACT_APP_TECHWORTH_URL}`}
                              >
                                Add Missing elements to increase your Pay
                              </Button>
                            </Box>

                            {/* Missing Fields List */}
                            <Grid container spacing={3}>
                              {missingFields.map((field) => (
                                <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
                                  <Paper
                                    sx={{
                                      color: "#FDF9E0",
                                      backgroundColor: "#E0011C",
                                      borderRadius: "10px",
                                      p: 2,
                                      display: "flex",
                                      boxShadow: "none",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Typography
                                      key={field}
                                      sx={{
                                        fontSize: {
                                          xs: "16px",
                                          md: "18px",
                                        },
                                        fontWeight: 600,
                                        textAlign: "center",
                                      }}
                                    >
                                      {fieldNameMappings[field] ||
                                        field.replace(/([A-Z])/g, " $1").trim()}
                                      {/* Use mapping; fallback: format camelCase */}
                                    </Typography>
                                  </Paper>
                                </Grid>
                              ))}
                            </Grid>
                          </CardContent>
                        </Box>
                      </Card>
                    </Box>
                  </Box>
                </Box>
              </SplideSlide>
            )}

            {convertedMarketSalary && (
              <SplideSlide>
                <Box sx={{ px: { xs: 2, sm: 3, md: 10 } }}>
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <Box
                      sx={{
                        minWidth: { xs: "100%", md: "100%", lg: "90%" },
                        maxWidth: { xs: "100%", md: "100%", lg: "90%" },
                      }}
                    >
                      <Card
                        sx={{
                          p: "10px",
                          background: "none !important",
                          border: "1px solid #FDF9E0",
                          borderRadius: "10px",
                          height: "500px", // Fixed height for the card
                          overflowY: "auto", // Enable vertical scrolling
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <Box
                          sx={{
                            flexGrow: 1,
                            overflowY: "auto",
                            padding: "10px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <CardContent
                            sx={{
                              p: "0 !important",
                              flexGrow: 1,
                              alignItems: "center",
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              {convertedMarketSalary && (
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Card
                                    sx={{
                                      border: `1px  dashed ${currentTheme.primary}`,
                                      borderRadius: "10px",
                                      boxShadow: "none",
                                      padding: "15px",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      backgroundColor: currentTheme.secondary,
                                    }}
                                  >
                                    <CardContent
                                      sx={{ p: "0 !important", flexGrow: 1 }}
                                    >
                                      <Box
                                        sx={{
                                          display: "flex",
                                          flexWrap: "wrap",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          gap: 1,
                                        }}
                                      >
                                        <Box
                                          component="img"
                                          sx={{
                                            height: "100%",
                                            width: "100%",
                                            maxHeight: {
                                              xs: "35px",
                                              md: "50px",
                                            },
                                            maxWidth: {
                                              xs: "35px",
                                              md: "50px",
                                            },
                                            color: "#FDF9E0",
                                          }}
                                          alt="Wallet Illustration"
                                          src="../../assets/images/wallet.png"
                                        />
                                        <Typography
                                          variant="h6"
                                          sx={{
                                            textAlign: "center",
                                            color: "green",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontSize: "18px",
                                            fontWeight: 700,
                                            color: "#FDF9E0",
                                          }}
                                        >
                                          Your Potential Salary :
                                        </Typography>
                                        <Typography
                                          variant="h3"
                                          sx={{
                                            color: "#FDF9E0",
                                            py: 1,
                                            fontWeight: 700,
                                          }}
                                        >
                                          {convertedMarketSalary[0]} -{" "}
                                          {convertedMarketSalary[1]}
                                        </Typography>
                                      </Box>
                                    </CardContent>
                                  </Card>
                                </Box>
                              )}
                            </Box>
                            {/* <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            {convertedTechValue && (
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <Card
                                  sx={{
                                    border: "1px  dashed #8DE49A",
                                    borderRadius: "10px",
                                    boxShadow: "none",
                                    padding: "15px",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    marginTop: 3,
                                    backgroundColor: "rgba(0, 255, 0, 0.05)",
                                  }}
                                >
                                  <CardContent
                                    sx={{ p: "0 !important", flexGrow: 1 }}
                                  >
                                    <Box
                                      sx={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: 1,
                                      }}
                                    >
                                      <Typography
                                        variant="h6"
                                        sx={{
                                          textAlign: "center",
                                          color: "green",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          fontSize: "18px",
                                          fontWeight: 700,
                                          color: "#fff",
                                        }}
                                      >
                                        Personalized Value you generate (for
                                        your Company) :
                                      </Typography>
                                      <Typography
                                        variant="h3"
                                        sx={{
                                          color: "#fff",
                                          py: 1,
                                          fontWeight: 700,
                                        }}
                                      >
                                        {convertedTechValue}
                                      </Typography>
                                    </Box>
                                  </CardContent>
                                </Card>
                              </Box>
                            )}
                          </Box> */}

                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                mt: 3,
                              }}
                            >
                              <Button
                                variant="contained"
                                sx={{
                                  backgroundColor: currentTheme.primary,
                                  textAlign: "center",
                                  borderRadius: "10px",
                                  fontWeight: {
                                    xs: 500,
                                    md: 700,
                                  },
                                  fontSize: {
                                    xs: "14px",
                                    md: "24px",
                                  },
                                  color: "#FDF9E0",
                                }}
                                color="primary"
                                target="_blank"
                                rel="noopener noreferrer"
                                href={`${process.env.REACT_APP_TECHWORTH_URL}`}
                              >
                                Get Better Salary Estimate
                              </Button>
                            </Box>
                          </CardContent>
                        </Box>
                      </Card>
                    </Box>
                  </Box>
                </Box>
              </SplideSlide>
            )}
          </Splide>
          {resultTime && (
            <Box
              sx={{
                textAlign: "center",
                fontSize: "14px",
                color: currentTheme.primary,
              }}
            >
              <p>{istTimeString}</p>
            </Box>
          )}
          {/* Inline Styling for Custom Navigation Arrows */}
          <style>
            {`
        .splide__arrow {
          background-color: ${currentTheme.primary};
          color: white;
          border-radius: 50%;
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .splide__arrow:hover {
          background-color:${currentTheme.primary};
        }

        .splide__pagination {
          margin-top: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .splide__pagination__page {
          background: #ddd;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          margin: 0 3px;
          cursor: pointer;
          transition: background 0.3s ease;
        }

        .splide__pagination__page.is-active {
          background: ${currentTheme.primary};
        }

       /* Center content inside slides */
          .splide__slide {
            margin-bottom: 50px;
          }

        /* margin the arrows for desktop */
        @media (min-width: 1440px) {
          .splide__arrow {
              margin-left: 80px;
              margin-right: 80px;
          }
        }
        ::-webkit-scrollbar {
          width: 8px;
        }

        ::-webkit-scrollbar-track {
          background: #231F20; /* Light gray background for the track */
          border-radius: 4px;  /* Subtle rounding for the track */
        }

        ::-webkit-scrollbar-thumb {
          background-color: #FDF9E0; /* Green color matching your design */
          border-radius: 3px;        /* Rounded thumb (half the width) */
        }

        ::-webkit-scrollbar-thumb:hover {
          background-color: ${currentTheme.primary}; /* Darker green on hover for interactivity */
        }

        `}
          </style>
        </Box>
      </>
    </ThemeProvider>
  );
};

export default ResultCarousel;
